"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.BodyOverlayCSS = void 0;
const react_1 = __importDefault(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const merlin_button_1 = require("@travelnest/merlin.button");
const merlin_icon_1 = require("@travelnest/merlin.icon");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const modal_styled_1 = __importDefault(require("./modal.styled"));
// https://github.com/reactjs/react-modal/issues/681#issuecomment-544234333
const BODY_CLASS = 'merlin-modal-body';
exports.BodyOverlayCSS = `
.${BODY_CLASS} {
	overflow: hidden;
	position: relative;

	#root {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		filter: blur(2px);
	}
}
`;
const Modal = (props) => {
    const { actionLHS, actionRHS, shouldCloseOnOverlayClick, onRequestClose, title, children, extraClasses } = props;
    react_modal_1.default.setAppElement('#root');
    return react_1.default.createElement(modal_styled_1.default, { className: extraClasses, bodyOpenClassName: BODY_CLASS, isOpen: true, onRequestClose: onRequestClose, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ? true : false, style: {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: '#eaeaea99',
                overflow: 'auto',
                zIndex: 2,
            },
            content: {
                position: 'absolute',
                border: `1px solid ${merlin_theme_1.default.colours.neutral.light}`,
                background: '#fff',
                WebkitOverflowScrolling: 'touch',
                outline: 'none',
                top: '10px',
                bottom: '80px',
                left: '10px',
                right: '10px',
                overflow: 'hidden',
                margin: 'auto',
                borderRadius: '5px',
                maxWidth: '600px',
                zIndex: 3,
                boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
            }
        } },
        react_1.default.createElement("div", { className: "travelnest-modal__header" },
            react_1.default.createElement("span", { className: "travelnest-modal__title" }, title),
            react_1.default.createElement(merlin_button_1.Button, { onClick: onRequestClose, bgColor: merlin_theme_1.default.colours.background.default, color: merlin_theme_1.default.colours.text.darkest, className: "travelnest-modal__button-close" },
                react_1.default.createElement("div", { className: "travelnest-modal__button-close-content" },
                    react_1.default.createElement(merlin_icon_1.Icon, { icon: "cross", colour: "darkGrey" }),
                    react_1.default.createElement("span", { className: "travelnest-modal__button-close-text" }, "Close")))),
        props.hero &&
            react_1.default.createElement("div", { className: "travelnest-modal__hero" }, props.hero),
        react_1.default.createElement("div", { className: "travelnest-modal__contain" },
            react_1.default.createElement("div", { className: "travelnest-modal__content" }, children)),
        (actionLHS || actionRHS) &&
            react_1.default.createElement("div", { className: "travelnest-modal__action-row" },
                actionLHS ? actionLHS : react_1.default.createElement("div", null),
                actionRHS));
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map